import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import { Chart } from '@kaizenplatform/kaizen-chartjs';

export const startFetchingIndexReport = () =>
  produce((draft: Draft<State>) => {
    draft.indexReportChart.fetching = draft.indexReportChart.fetching + 1;
  });

export const setIndexReport = (indexReportChart: Chart[] | Chart) =>
  produce((draft: Draft<State>) => {
    draft.indexReportChart.data = indexReportChart;
  });

export const finishFetchingIndexReport = () =>
  produce((draft: Draft<State>) => {
    draft.indexReportChart.fetching = draft.indexReportChart.fetching - 1;
  });

export const disposeIndexReport = () =>
  produce((draft: Draft<State>) => {
    draft.indexReportChart.data = initialState.indexReportChart.data;
    draft.indexReportChart.fetching = initialState.indexReportChart.fetching;
  });
